let audioContext: AudioContext | null = null;

const getAudioContext = () => {
  if (audioContext) return audioContext;
  if (typeof window === "undefined") return null;
  const AudioContextConstructor = window.AudioContext ||
    (window as Window & { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
  if (!AudioContextConstructor) return null;
  audioContext = new AudioContextConstructor();
  return audioContext;
};

// Resume during a real user gesture so later replies can make a sound.
export const prepareChatNotificationSound = () => {
  try {
    const context = getAudioContext();
    if (context && context.state !== "running") void context.resume().catch(() => {});
  } catch {
    // Audio is optional in browsers that do not support it.
  }
};

export const playChatNotificationSound = () => {
  try {
    const context = getAudioContext();
    if (!context) return;
    const requestedAt = Date.now();
    const play = () => {
      const start = context.currentTime;
      const oscillator = context.createOscillator();
      const gain = context.createGain();
      oscillator.type = "sine";
      oscillator.frequency.setValueAtTime(620, start);
      oscillator.frequency.exponentialRampToValueAtTime(830, start + 0.2);
      gain.gain.setValueAtTime(0.001, start);
      gain.gain.exponentialRampToValueAtTime(0.06, start + 0.035);
      gain.gain.exponentialRampToValueAtTime(0.001, start + 0.25);
      oscillator.connect(gain);
      gain.connect(context.destination);
      oscillator.start(start);
      oscillator.stop(start + 0.26);
      oscillator.onended = () => { oscillator.disconnect(); gain.disconnect(); };
    };

    if (context.state === "running") play();
    else void context.resume().then(() => {
      if (Date.now() - requestedAt < 1000) play();
    }).catch(() => {});
  } catch {
    // Browsers can block audio until the user interacts with the page.
  }
};
